import React, { useEffect, useState } from "react";

import { ClipboardIcon } from "lucide-react"; // Install lucide-react for icons
import { FaRegCopy } from "react-icons/fa"; // Install react-icons if not installed
import { Clipboard } from "lucide-react"; // Importing icon
import { CheckCircle, XCircle } from "lucide-react";
import { format } from "mathjs";
import styled from "styled-components";


import toast from "react-hot-toast";

import Rewards from "./Rewards"

import Hero from "./Hero";
import CardSection from "./CardSection"
import WhyScalio from "./WhyScalio"
import GlobalFootprint from "./GlobalFootprint"
import Features from "./Features"
import Footer from "./Footer"
import Navbar from './Navbar'
import Partners from "./Partners"

import PremiumCard from "./PremiumCard"
import HowItWorks from "./HowItWorks"
import FAQ from "./FAQ"
import FinalCTA from "./FinalCTA"


/* =========================
   VIDEO COMPONENT
========================= */


export default function PricePerToken() {
  const [open, setOpen] = useState(false);

  const navItemClass = `
    text-white
    font-['Outfit']
    text-[16px]
    font-normal
    leading-[16px]
    transition-colors
    duration-200
    hover:text-[#FFE64B]
  `;
  return (

 <div className="w-[85] mx-auto ">

      {/* FIXED NAV WRAPPER */}
 <Navbar/>

      {/* PAGE OFFSET */}

      <Hero/>
      <GlobalFootprint/>
      <WhyScalio/>
       <CardSection />
           
      <Features />

     


    <FAQ/>

    <FinalCTA/>
      <Footer />
    </div>
  );
}
